'use client';

import { useModal } from '@/app/pageContext';

import { Button, Frame } from './primitives';

export function CTA({
  heading,
  body,
  perks,
  button,
  fineprint,
}: {
  heading: string;
  body: string;
  perks: string[];
  button: string;
  fineprint: string;
}) {
  const { openModal } = useModal();
  return (
    <Frame as="section" id="early-access" aria-labelledby="cta-heading" className="on-ink relative scroll-mt-24 bg-ink-950 text-white">
      <div aria-hidden="true" className="beacon-glow absolute inset-0" />
      <div className="relative grid grid-cols-1 gap-12 px-6 py-16 sm:px-10 sm:py-24 lg:grid-cols-12 lg:gap-8 lg:px-16 lg:py-32">
        <div className="lg:col-span-7">
          <h2
            id="cta-heading"
            className="font-display max-w-[14ch] text-balance text-[clamp(2.5rem,5.6vw,4.75rem)] leading-[0.98] font-extrabold tracking-[-0.035em]"
          >
            {heading}
          </h2>
          <p className="mt-7 max-w-[34rem] text-pretty text-lg leading-relaxed text-mist sm:text-xl">{body}</p>
          <div className="mt-10 flex flex-wrap items-center gap-x-6 gap-y-4">
            <Button variant="white" className="px-7" onClick={openModal}>
              {button}
            </Button>
            <p className="text-sm text-mist">{fineprint}</p>
          </div>
        </div>
        <ul className="grid grid-cols-1 gap-3 lg:col-span-5 lg:self-end">
          {perks.map((perk, i) => (
            <li key={perk} className="flex items-start gap-4 rounded-[1.25rem] bg-white/[0.07] p-5 backdrop-blur-sm">
              <span className="font-display tabular shrink-0 text-[0.9rem] font-bold text-beacon-400" aria-hidden="true">
                {String(i + 1).padStart(2, '0')}
              </span>
              <span className="text-pretty text-[0.95rem] leading-snug text-white/90">{perk}</span>
            </li>
          ))}
        </ul>
      </div>
    </Frame>
  );
}
